'use client';
import { motion } from 'framer-motion';
import { DIMMED_OPACITY, HOVER_TRANSITION, MILESTONE_SIZE } from './gantt-constants';
import { GanttTaskStatus, type GanttTaskLayout } from './gantt-types';
export interface GanttMilestoneProps {
    taskLayout: GanttTaskLayout;
    color: string;
    glowFilterId: string;
    isDimmed: boolean;
    isHovered: boolean;
    rowIndex: number;
}
export function GanttMilestone({ taskLayout, color, glowFilterId, isDimmed, isHovered, rowIndex, }: GanttMilestoneProps) {
    if (taskLayout.task.status !== GanttTaskStatus.Milestone) {
        return null;
    }
    const centerX = taskLayout.x + MILESTONE_SIZE / 2;
    const centerY = taskLayout.centerY;
    return (
      <motion.g data-el="Cmarkdowngantt/Milestone/Root" initial={{ opacity: 0, scale: 0.7 }} animate={{
            opacity: isDimmed ? DIMMED_OPACITY : 1,
            scale: 1,
        }} transition={{
            opacity: {
                duration: 0.24,
                delay: rowIndex * 0.04,
                ease: 'easeOut',
            },
            scale: {
                duration: 0.28,
                delay: rowIndex * 0.04,
                ease: [0.4, 0, 0.2, 1],
            },
        }} style={{ transition: HOVER_TRANSITION }} filter={isHovered ? `url(#${glowFilterId})` : undefined}>
        <rect x={centerX - MILESTONE_SIZE / 2} y={centerY - MILESTONE_SIZE / 2} width={MILESTONE_SIZE} height={MILESTONE_SIZE} transform={`rotate(45 ${centerX} ${centerY})`} fill={color} stroke={`${color}99`} strokeWidth={1}/>
      </motion.g>
    );
}
